import type {
  AdminCreateProjectInput,
  AdminGetProjectAgentLinksParams,
  AdminGetProjectParams,
  AdminGetProjectPriceExprParams,
  AdminListProjectAgentLinksParams,
  AdminListProjectsParams,
  AdminSetProjectDefaultPhotoInput,
  AdminSetProjectMarketDetailsInput,
  AdminSetProjectPriceExprInput,
  AdminSetProjectPriorityInput,
  AdminUpdateProjectAgentLinkStatusInput,
  RequestParams,
  AdminPrepareProjectDocumentUploadInput,
  AdminVerifyProjectDocumentUploadInput,
  AdminPrepareProjectLogoUploadInput,
  AdminVerifyProjectLogoUploadInput,
  AdminPrepareProjectPhotoUploadInput,
  AdminVerifyProjectPhotoUploadInput,
} from '../api'
import { api, ContentType } from '../api'

const adminGetProjectDetails = async (data: AdminGetProjectParams) => {
  return await api.v1.adminGetProject(data)
}

const adminListProjects = async (data: AdminListProjectsParams) => {
  return await api.v1.adminListProjects(data)
}

const adminCreateProject = async (data: AdminCreateProjectInput) => {
  return await api.v1.adminCreateProject(data)
}

const adminUploadProjectPhoto = async (formData: FormData) => {
  return await api.v1.adminUploadProjectPhoto({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const adminUploadProjectLogo = async (formData: FormData) => {
  return await api.v1.adminUploadProjectLogo({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const adminUploadProjectDocument = async (formData: FormData) => {
  return await api.v1.adminUploadProjectDocument({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const adminPrepareProjectDocumentUpload = async (
  data: AdminPrepareProjectDocumentUploadInput,
) => {
  return await api.v1.adminPrepareProjectDocumentUpload(data)
}

const adminVerifyProjectDocumentUpload = async (
  data: AdminVerifyProjectDocumentUploadInput,
) => {
  return await api.v1.adminVerifyProjectDocumentUpload(data)
}

const adminPrepareProjectLogoUpload = async (
  data: AdminPrepareProjectLogoUploadInput,
) => {
  return await api.v1.adminPrepareProjectLogoUpload(data)
}

const adminVerifyProjectLogoUpload = async (
  data: AdminVerifyProjectLogoUploadInput,
) => {
  return await api.v1.adminVerifyProjectLogoUpload(data)
}

const adminPrepareProjectPhotoUpload = async (
  data: AdminPrepareProjectPhotoUploadInput,
) => {
  return await api.v1.adminPrepareProjectPhotoUpload(data)
}

const adminVerifyProjectPhotoUpload = async (
  data: AdminVerifyProjectPhotoUploadInput,
) => {
  return await api.v1.adminVerifyProjectPhotoUpload(data)
}

const adminSetProjectDefaultPhoto = async (
  data: AdminSetProjectDefaultPhotoInput,
) => {
  return await api.v1.adminSetProjectDefaultPhoto(data)
}

const adminDeleteProjectDocument = async (
  projectId: number,
  documentId: number,
) => {
  return await api.v1.adminDeleteProjectDocument({ projectId, documentId })
}

const adminDeleteProjectPhoto = async (projectId: number, photoId: number) => {
  return await api.v1.adminDeleteProjectPhoto({ projectId, photoId })
}

const adminSetProjectMarketDetails = async (
  data: AdminSetProjectMarketDetailsInput,
) => {
  return await api.v1.adminSetProjectMarketDetails({ token: data.token! }, data)
}

const adminSetProjectPriceExpr = async (
  data: AdminSetProjectPriceExprInput,
) => {
  return await api.v1.adminSetProjectPriceExpr(data)
}

const adminGetProjectPriceExpr = async (
  data: AdminGetProjectPriceExprParams,
) => {
  return await api.v1.adminGetProjectPriceExpr(data)
}

const adminSetProjectPriority = async (data: AdminSetProjectPriorityInput) => {
  return await api.v1.adminSetProjectPriority(data)
}

const adminUpdateProjectAgentLinkStatus = async (
  data: AdminUpdateProjectAgentLinkStatusInput,
) => {
  return await api.v1.adminUpdateProjectAgentLinkStatus(data)
}

const adminListProjectAgentLinks = async (
  data: AdminListProjectAgentLinksParams,
) => {
  return await api.v1.adminListProjectAgentLinks(data)
}

const adminGetProjectAgentLinks = async (
  data: AdminGetProjectAgentLinksParams,
) => {
  return await api.v1.adminGetProjectAgentLinks(data)
}

export default {
  adminGetProjectDetails,
  adminListProjects,
  adminCreateProject,
  adminUploadProjectPhoto,
  adminUploadProjectDocument,
  adminUploadProjectLogo,
  adminSetProjectDefaultPhoto,
  adminDeleteProjectDocument,
  adminDeleteProjectPhoto,
  adminSetProjectMarketDetails,
  adminSetProjectPriceExpr,
  adminGetProjectPriceExpr,
  adminSetProjectPriority,
  adminUpdateProjectAgentLinkStatus,
  adminListProjectAgentLinks,
  adminGetProjectAgentLinks,
  adminPrepareProjectDocumentUpload,
  adminVerifyProjectDocumentUpload,
  adminPrepareProjectLogoUpload,
  adminVerifyProjectLogoUpload,
  adminPrepareProjectPhotoUpload,
  adminVerifyProjectPhotoUpload,
}
